import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { getCompletedAsyncWrapperObj } from '@ane/core/lib/models';
import { produceLoadLoadingLoadedEpic } from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { loadingServicePrincipalNameList, loadedServicePrincipalNameList, loadServicePrincipalNameListActionTypes, } from './ComputeCreateContainer.ducks';
import AuthenticationResource from '@ane/exp-data/lib/resources/AuthenticationResources';
export const getComputeServicePrincipalEpic = produceLoadLoadingLoadedEpic({
    filterOnType: loadServicePrincipalNameListActionTypes.LOAD,
    loadResource: (payload) => {
        return AuthenticationResource.getServicePrincipalNameList(payload.workspaceId);
    },
    loadingAction: (payload) => loadingServicePrincipalNameList(payload.workspaceId),
    loadedAction: (successData, payload, error) => {
        return of(loadedServicePrincipalNameList(payload.workspaceId, getCompletedAsyncWrapperObj(successData, error)));
    },
});
export default combineEpics(getComputeServicePrincipalEpic);

//# sourceMappingURL=ComputeServicePrincipalEpic.js.map
